module.exports = __webpack_public_path__ + "img/carousel-2.0f828d84.jpg";